import React, { useEffect, useState } from 'react'

import BlankCertificate from '../../img/Impact-Directors-Certificate.png'
import FontAbhaya from '../../AbhayaLibre-SemiBold.ttf'
import RobotoBold from '../../Roboto-Bold.ttf'
import AbhayaRegular from '../../AbhayaLibre-Regular.ttf'
import AbhayaBold from '../../AbhayaLibre-Bold.ttf'
import GoodVibrations from '../../GoodVibrations Script.ttf'
import PoppinsSemiBold from '../../Poppins-SemiBold.ttf'
import PoppinsRegular from '../../Poppins-Regular.ttf'
import QRCode from 'qrcode'
import { Document, Page, Text, View, StyleSheet, Image, Font, } from '@react-pdf/renderer';
import moment from "moment";
import axios from "axios";

const ParticipantionCertificateForImpact = (props) => {
    var JSToken;
    var accessToken;
    if (localStorage.user) {
      JSToken = JSON.parse(localStorage.user);
      accessToken = JSToken.access_token;
    }
    const config = {
      headers: { Authorization: `Bearer ${accessToken}` },
    };

    if (
        (
          props.FirstName +
          props.LastName
        ).length > 25
      )  {  // console.log("SAdsadsadasdasdasd");
      var setFontSize = 36;
      var setFullNameTop = 389.7;
      var setLowerViewTop =390;
      var setcomplete =401.0;
    } else {
        // console.log("kkkkkkkkkkkk");
      var setFontSize = 44;
      var setFullNameTop = 378.7;
      var setLowerViewTop = 387.2;
      var setcomplete = 390.2;
    }

    Font.register({
        family: "AbhayaLibreSemiBold",
        src: FontAbhaya,
      });
      Font.register({
        family: "RobotoBold",
        src: RobotoBold,
      });
      Font.register({
        family: "AbhayaRegular",
        src: AbhayaRegular,
      });
      Font.register({
        family: "AbhayaBold",
        src: AbhayaBold,
      });  Font.register({
        family: "PoppinsSemiBold",
        src: PoppinsSemiBold,
      }); Font.register({
        family: "GoodVibrations",
        src: GoodVibrations,
      }); 
      Font.register({
        family: "PoppinsRegular",
        src: PoppinsRegular,
      });
      const SIGNATURE_DIMENSIONS = {
        minWidth: 120,
        maxWidth: 130,
        minHeight: 50,
        maxHeight: 70,
        defaultWidth: 120,
        defaultHeight: 52,
      };
      const SIGNATURE_LEFT = 653;
      const SIGNER_BLOCK_WIDTH = 220;
      const SIGNER_BLOCK_CENTER_X =
        SIGNATURE_LEFT + SIGNATURE_DIMENSIONS.defaultWidth / 2;
      const styles = StyleSheet.create({
        page: {},
        section: {
          margin: 10,
          padding: 10,
          flexGrow: 1,
        },
        viewer: {
          width: 870,
          height: 690,
        },
        bgimages: {
          height:595,
          width:842,
          position: 'absolute'
        },
        title: {
          top: 15,
          textAlign: "center",
          fontSize: 58,
          color: "white",
          fontFamily: "AbhayaLibreSemiBold",
        },
        participation: {
          top: 15,
          textAlign: "center",
          fontSize: 21,
          color: "#F3D649",
          fontFamily: "RobotoBold",
        },
        initialline: {
          letterSpacing: 1.5,
          top: 210,
          textAlign: "center",
          fontSize: 16,
          color: "#000000",
          fontFamily: "AbhayaRegular",
        },
        showcase: {
        //   top: 250,
        marginTop:2,
          textAlign: "center",
          fontSize: 12,
          color: "#000000",
          fontFamily: "PoppinsRegular",
          marginHorizontal: 160,
        },
        complete: {
          top: 260,
          textAlign: "center",
          fontSize: 16,
          color: "#000000",
          fontFamily: "AbhayaRegular",
        },
        completeDate: {
        
            top:410.8,
            left:96.5,
            textAlign: "start",
            fontSize: 13,
            color: "#4c8dcb",
            fontFamily: "PoppinsRegular",
        },
        completeLocation: {
          top: 260,
          textAlign: "center",
          fontSize: 16,
          color: "#000000",
          fontFamily: "AbhayaRegular",
        },
        fullname: {
          textAlign: "center",
          color: "#4c8dcb",
          fontFamily: "AbhayaRegular",
        },
        headNameRight: {
          top:288,
          textAlign: "center",
          fontSize: 16,
          color: "#4c8dcb",
          fontFamily: "AbhayaBold",
        },
        headNameLeft: {
          top:288,
          textAlign: "center",
          fontSize: 16,
          color: "#4c8dcb",
          fontFamily: "AbhayaBold",
          marginLeft: 18,
        },
        headPositionRight: {
          top:286,
          textAlign: "center",
          fontSize: 12,
          color: "#000000",
          fontFamily: "RobotoBold",
          marginRight: 45,
        },
        headPositionLeft: {
          top:286,
          textAlign: "center",
          fontSize: 12,
          color: "#000000",
          fontFamily: "RobotoBold",
          marginLeft: 55,
        },
        QRImage: {
          top:504,
          left: 390,
          position: "absolute",
          width: 75,
        },
        signatureImage:{
          top:467,
          left:SIGNATURE_LEFT,
          width:SIGNATURE_DIMENSIONS.defaultWidth,
          height:SIGNATURE_DIMENSIONS.defaultHeight,
          minWidth:SIGNATURE_DIMENSIONS.minWidth,
          maxWidth:SIGNATURE_DIMENSIONS.maxWidth,
          minHeight:SIGNATURE_DIMENSIONS.minHeight,
          maxHeight:SIGNATURE_DIMENSIONS.maxHeight,
          position:'absolute',
          objectFit:'contain'
        },
        signerBlock:{
          top:540,
          left:SIGNER_BLOCK_CENTER_X - SIGNER_BLOCK_WIDTH / 2,
          width:SIGNER_BLOCK_WIDTH,
          alignItems:'center',
          position:'absolute'
        },
        signerName:{
          width:'100%',
          textAlign:'center',
          fontSize:10,
          color:'#009EDC',
          fontFamily:'PoppinsRegular',
          textTransform:'uppercase'
        },
        signerDesignation:{
          width:'100%',
          marginTop:1,
          textAlign:'center',
          fontSize:9,
          color:'#000000',
          fontFamily:'RobotoBold',
          textTransform:'uppercase'
        }
      });
    // States
   
    const [qrUriImageFile, setqrUriImageFile] = useState();
    const [isCertificateReady, setIsCertificateReady] = useState(false);
    const [certificateLoadError, setCertificateLoadError] = useState("");
    const [certificateDetails, setCertificateDetails] = useState({
      signer: "",
      designation: "",
      signatureImage: null,
    });
  
  const generateQR = async (text) => {
    try {
      setqrUriImageFile(
        await QRCode.toDataURL(text, {
          color: {
            dark: "#009EDC", // Blue dots
            light: "#0000", // Transparent background
          },
        })
      );
    } catch (err) {
      console.error(err);
    }
  };
  const getFirstDefinedValue = (source, keys) => {
    for (let index = 0; index < keys.length; index += 1) {
      const value = source?.[keys[index]];
      if (value !== undefined && value !== null && `${value}`.trim() !== "") {
        return `${value}`.trim();
      }
    }
    return "";
  };

  const blobToDataUri = (blobData) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blobData);
    });

  const fetchSignatureImage = async (signatureFileUrl) => {
    const normalizedSignatureUrl = `${signatureFileUrl || ""}`.trim();
    if (!normalizedSignatureUrl) {
      return null;
    }

    if (normalizedSignatureUrl.startsWith("data:")) {
      return normalizedSignatureUrl;
    }

    try {
      const signatureDownloadUrl =
        normalizedSignatureUrl.startsWith("http://") ||
        normalizedSignatureUrl.startsWith("https://")
          ? normalizedSignatureUrl
          : `https://dash.bestdiplomats.org/api/method/frappe.core.doctype.file.file.download_file?file_url=${encodeURIComponent(normalizedSignatureUrl)}`;

      const signatureResponse = await axios.get(signatureDownloadUrl, {
        ...config,
        responseType: "blob",
      });
      return await blobToDataUri(signatureResponse.data);
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  useEffect(() => {
    generateQR(props.qrText);
  }, [props.qrText]);

  useEffect(() => {
    let isMounted = true;

    const fetchCertificateDetails = async () => {
      setIsCertificateReady(false);
      setCertificateLoadError("");

      if (!props?.eventid) {
        setCertificateLoadError("Event id is missing.");
        return;
      }

      try {
        const certificateListResponse = await axios.get(
          `https://dash.bestdiplomats.org/api/resource/Certificates%20Info?filters=[["events","=","${props.eventid}"]]&order_by=creation desc&limit_page_length=1`,
          config
        );
        const certificateName = certificateListResponse?.data?.data?.[0]?.name;
        if (!certificateName) {
          throw new Error("Certificate information is missing for this event.");
        }

        const certificateResponse = await axios.get(
          `https://dash.bestdiplomats.org/api/resource/Certificates%20Info/${encodeURIComponent(certificateName)}`,
          config
        );
        const certificateData = certificateResponse?.data?.data || {};
        const signer = getFirstDefinedValue(certificateData, [
          "signer",
          "signer_name",
          "sender_name",
          "signed_by",
        ]);
        const designation = getFirstDefinedValue(certificateData, [
          "designation",
          "signer_designation",
          "sender_designation",
        ]);
        const signatureField = getFirstDefinedValue(certificateData, [
          "signature",
          "signer_signature",
          "sender_signature",
        ]);
        const signatureImage = await fetchSignatureImage(signatureField);

        if (!isMounted) {
          return;
        }

        setCertificateDetails({
          signer,
          designation,
          signatureImage,
        });
        setIsCertificateReady(true);
      } catch (error) {
        console.log(error);
        if (!isMounted) {
          return;
        }
        setCertificateLoadError(
          error?.message ||
            "Certificate cannot be generated because required API data is missing."
        );
      }
    };

    fetchCertificateDetails();

    return () => {
      isMounted = false;
    };
  }, [props.eventid]);

  if (!isCertificateReady || certificateLoadError) {
    return null;
  }

  return (
  <Document>
    {/* <Page size={[842,595]} >
    <Image src={BlankCertificate} style={styles.bgimages}></Image>
 
    <Text style={styles.participation}>{props?.type}</Text>
    <Text  style={{
                          top: setFullNameTop,
                          fontSize: setFontSize,
                          textAlign: "center",
                           textTransform: "capitalize",

                          color: "#009EDC",
                          fontFamily: "GoodVibrations",
                        }}>{""}{""+(props.FirstName)?.toLowerCase()+" "+(props.LastName)?.toLowerCase()}</Text>
    <View  style={{ top: setLowerViewTop }}>
    <Text style={styles.showcase}>{props.first_line+" "+props?.country}</Text>
   </View>
    <Text style={{ top:setcomplete,
                            left:96.5,
                            textAlign: "start",
                            fontSize: 13,
                            color: "#000000",
                            fontFamily: "PoppinsRegular",}}>
            {moment(props?.end_date).format(
              "D MMMM, YYYY"
            ) }
          </Text>
    <Image source={qrUriImageFile} style={styles.QRImage}></Image>

    </Page> */}
      <Page size={[842, 595]}>
                     <Image
                        src={BlankCertificate}
                        style={styles.bgimages}
                      ></Image>
                   
                      <Text
                        style={{
                          top: setFullNameTop,
                          textTransform: "capitalize",
                          fontSize: setFontSize,
                          textAlign: "center",
                          color: "#009EDC",
                          fontFamily: "AbhayaRegular",
                        }}
                      >
                        {""}
                        {""+(props.FirstName)?.toLowerCase()+" "+(props.LastName)?.toLowerCase()}
                      </Text>
                      
                      <View style={{ top: setLowerViewTop }}>
                      <Text style={{
                           marginTop: 2,
                          fontSize: 14,
                          textAlign: "center",
                          color: "#000000",
                          fontFamily: "PoppinsSemiBold",
                        }} >{ props.first_line==undefined||props.first_line==null||props.first_line==""?"    ":props.first_line}</Text>
                        <Text style={styles.showcase}>In recognition of your visionary thinking, strategic planning and innovative problem solving at Impact Directors {props?.country}.</Text>

                      
                         
                        </View>

                      <Text style={
                        {  top:setcomplete,
                            left:80,
                            textAlign: "start",
                            fontSize: 13,
                            color: "#000000",
                            fontFamily: "PoppinsRegular",}
                      }>
                            {moment(props?.end_date).format(
              "Do MMMM YYYY"
             )}
                          </Text>
                      {certificateDetails?.signatureImage && (
                        <Image source={certificateDetails.signatureImage} style={styles.signatureImage}></Image>
                      )}
                      {(certificateDetails?.signer || certificateDetails?.designation) && (
                        <View style={styles.signerBlock}>
                          {certificateDetails?.signer && (
                            <Text style={styles.signerName}>{certificateDetails.signer}</Text>
                          )}
                          {certificateDetails?.designation && (
                            <Text style={styles.signerDesignation}>{certificateDetails.designation}</Text>
                          )}
                        </View>
                      )}
                      {/* <Image
                        source={generateQR(
                          `https://verify.impactdirectors.org/verify/${response.data.data[index]?.delegate_profile.name}-${eventId}-${response.data.data[index]?.name}`
                        )}
                        style={styles.QRImage}
                      ></Image> */}
                    </Page>
  </Document>
  )
}

export default ParticipantionCertificateForImpact
